import React from 'react'
import { Stamp } from './style'

export default () => {

    return <Stamp>Patrocinado</Stamp>
}